import http from './http'
const base = '/Telas/RelatoriosGerenciais'
export default {
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async get (params) { return (await http.get(`${base}/Get`, { params })).data },
  async exportCsv (params) { return (await http.get(`${base}/ExportCsv`, { params, responseType: 'blob' })).data }
}
